import { z } from 'zod'

const BaseParamsSchema = z.object({
    offerId: z.number(),
    priceCurrency: z.string(),
    priceValue: z.number(),
    quantity: z.number(),
})

export type BaseParams = z.infer<typeof BaseParamsSchema>

const AdyenSidebarParamsSchema = z.object({
    imageURL: z.string(),
    titleText: z.string(),
    priceLabelText: z.string(),
})

export type AdyenSidebarParams = z.infer<typeof AdyenSidebarParamsSchema>

export const ShowPortalPaymentDialogParamsSchema = z.object({
    ...BaseParamsSchema.shape,
    ...AdyenSidebarParamsSchema.shape,
})

export type ShowPortalPaymentDialogParams = z.infer<typeof ShowPortalPaymentDialogParamsSchema>

const OnResultSchema = z.custom<(result: boolean) => void>()

const AdyenPaymentDialogParamsSchema = z.object({
    onResult: OnResultSchema,
    ...BaseParamsSchema.shape,
    ...AdyenSidebarParamsSchema.shape,
})

export type AdyenPaymentDialogParams = z.infer<typeof AdyenPaymentDialogParamsSchema>

const XsollaPaymentDialogParamsSchema = z.object({
    onResult: OnResultSchema,
    ...BaseParamsSchema.shape,
})

export type XsollaPaymentDialogParams = z.infer<typeof XsollaPaymentDialogParamsSchema>

const CodaPaymentDialogParamsSchema = z.object({
    onResult: OnResultSchema,
    ...BaseParamsSchema.shape,
})

export type CodaPaymentDialogParams = z.infer<typeof CodaPaymentDialogParamsSchema>
